import { combineReducers } from 'redux';

import paramsReducer from './paramsReducer';

import {
  contentProviders,
  customers,
  jobConfigs,
  jobConfigTemplates,
  jobs,
  kiosks,
  marketing,
  members,
  moments,
  purchases,
  uploads,
  billings,
  accountBillings,
  accounts,
  accountPricings,
  billingExportSched,
  salesReport,
  photogHourlyReport,
  analyticsReport,
  catalogs,
  guests,
  accessCodePages
} from 'app/resources';

import {
  // resource setters
  SET_CONTENT_PROVIDERS,
  SET_CUSTOMERS,
  SET_JOB_CONFIGS,
  SET_JOB_CONFIG_TEMPLATES,
  SET_JOBS,
  SET_KIOSKS,
  SET_MARKETING,
  SET_MEMBERS,
  SET_MOMENTS,
  SET_PURCHASES,
  SET_UPLOADS,
  SET_BILLINGS,
  SET_ACCOUNT_BILLINGS,
  SET_ACCOUNTS,
  SET_ACCOUNT_PRICINGS,
  SET_BILLING_EXPORT_SCHEDULES,
  SET_SALES_REPORT,
  SET_PHOTOG_HOURLY_REPORT,
  SET_ANALYTICS_REPORT,
  SET_GUESTS,
  SET_ACCESS_CODE_PAGES
} from 'app/actions/types';

// note - the params reducer names should be the resource text value
// (which is the resource name in camelCase).
// this enables looking up the state by knowing the resource.
// the params reducer itself should just be "params",
// so that jobConfigs can be selected with `state.params.jobConfigs`
const params = combineReducers({
  [contentProviders]: paramsReducer(contentProviders, SET_CONTENT_PROVIDERS),
  [customers]: paramsReducer(customers, SET_CUSTOMERS),
  [jobConfigs]: paramsReducer(jobConfigs, SET_JOB_CONFIGS),
  [jobConfigTemplates]: paramsReducer(jobConfigTemplates, SET_JOB_CONFIG_TEMPLATES),
  [jobs]: paramsReducer(jobs, SET_JOBS),
  [kiosks]: paramsReducer(kiosks, SET_KIOSKS),
  [marketing]: paramsReducer(marketing, SET_MARKETING),
  [members]: paramsReducer(members, SET_MEMBERS),
  [moments]: paramsReducer(moments, SET_MOMENTS),
  [purchases]: paramsReducer(purchases, SET_PURCHASES),
  [uploads]: paramsReducer(uploads, SET_UPLOADS),
  [billings]: paramsReducer(billings, SET_BILLINGS),
  [accountBillings]: paramsReducer(accountBillings, SET_ACCOUNT_BILLINGS),
  [accounts]: paramsReducer(accounts, SET_ACCOUNTS),
  [accountPricings]: paramsReducer(accountPricings, SET_ACCOUNT_PRICINGS),
  [billingExportSched]: paramsReducer(billingExportSched, SET_BILLING_EXPORT_SCHEDULES),
  [salesReport]: paramsReducer(salesReport, SET_SALES_REPORT),
  [photogHourlyReport]: paramsReducer(photogHourlyReport, SET_PHOTOG_HOURLY_REPORT),
  [analyticsReport]: paramsReducer(analyticsReport, SET_ANALYTICS_REPORT),
  [catalogs]: paramsReducer(catalogs, SET_JOBS),
  [guests]: paramsReducer(guests, SET_GUESTS),
  [accessCodePages]: paramsReducer(accessCodePages, SET_ACCESS_CODE_PAGES)
});

export default params;
